module.exports = __webpack_public_path__ + "img/ic_12_delete.6ed45298.svg";